exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.btn-height[data-v-5909d73d] {\n  height: 39px;\n}\n.price-category-description[data-v-5909d73d] {\n  font-size: 2rem;\n}\n.modal-height[data-v-5909d73d] {\n  overflow-y: visible;\n  height: 22rem;\n}\n.drop-size[data-v-5909d73d] {\n  width: 15rem;\n}\n.thead-size[data-v-5909d73d] {\n  height: 40px;\n}\n.tr-size[data-v-5909d73d] {\n  height: 60px;\n}\n.min-size[data-v-5909d73d] {\n  min-height: 14rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-5909d73d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/GenderPricesDependencies.vue
// module id = 1541
// module chunks = 0